// Constants
import {
  AMOUNT,
  FINANCIAL_LIST_PROPS,
  INTERESTS,
  MONTHLY,
  PAYMENT,
  SHIPPING,
  TOTAL,
} from '../constants/contract.constants';
// Types
import { ContractHandlersBuilderType, ContractHandlersType } from './types/contract.handlers.type';
// Utils
import { checkHandleOnBackHeader } from 'utils/app-back.utils';
import { createTagAndsDispatchFile } from '@openbank/cf-ui-framework';

const setupFinancialPreContractDataHandler = ({
  flowApiData,
  setFinancialData,
}: ContractHandlersBuilderType): void => {
  if (flowApiData) {
    FINANCIAL_LIST_PROPS[AMOUNT].value = flowApiData.amount;
    FINANCIAL_LIST_PROPS[INTERESTS].value = flowApiData.totalInterestAmount;
    FINANCIAL_LIST_PROPS[INTERESTS].nominalInterest = flowApiData.nominalInterest;
    FINANCIAL_LIST_PROPS[INTERESTS].interestRate = flowApiData.interestRate;
    FINANCIAL_LIST_PROPS[TOTAL].value = flowApiData.totalAmount;
    FINANCIAL_LIST_PROPS[SHIPPING].value = flowApiData.installmentAmount;
    FINANCIAL_LIST_PROPS[MONTHLY].value = flowApiData.installmentAmount;
    FINANCIAL_LIST_PROPS[MONTHLY].installments = flowApiData.installmentsNumber;
    FINANCIAL_LIST_PROPS[PAYMENT].value = flowApiData.paymentMethod;
    FINANCIAL_LIST_PROPS[PAYMENT].accounts = flowApiData?.accounts;
    setFinancialData(FINANCIAL_LIST_PROPS);
  }
};

const downloadDocumentHandler = ({ blob, formatMessage, fileName }) => {
  createTagAndsDispatchFile({ blob, filename: `${formatMessage({ id: fileName })}.pdf` });
};

const ContractHandlers = (props: ContractHandlersBuilderType): ContractHandlersType => ({
  handleDownloadDocument: (fileName: string, blob: Blob) =>
    downloadDocumentHandler({
      fileName,
      blob,
      formatMessage: props.formatMessage,
    }),
  handleOnBackHeader: () => checkHandleOnBackHeader(props),
  handleSetupFinancialContractData: () => setupFinancialPreContractDataHandler(props),
});

export { ContractHandlers };
